import { HydratedRouter } from 'react-router/dom'
import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import initializeClientI18n from './i18n/initialize-client-i18n'
import getEnv from '~/core/get-env'
import { loadSelectedTheme } from '~/core/theming'
import configuration from '~/configuration'
import clearBrowserExtensionInjectionsBeforeHydration from '~/core/generic/fix-hydration'

const hydrate = () => {
  clearBrowserExtensionInjectionsBeforeHydration()

  startTransition(() => {
    initializeClientI18n().then(async (i18next) => {
      const App = (
        <StrictMode>
          <I18nextProvider i18n={i18next}>
            <HydratedRouter />
          </I18nextProvider>
        </StrictMode>
      )

      if (isTestEnv()) {
        const { hydrate } = await import('react-dom')
        hydrate(App, document)
      } else {
        hydrateRoot(document, App)
      }
    })
  })
}

if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrate)
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  window.setTimeout(hydrate, 1)
}

function isTestEnv() {
  return getEnv().IS_CI === 'true'
}

if (configuration.features.enableThemeSwitcher) {
  loadSelectedTheme()
}
